export default "__VITE_ASSET__CstHZCU1__"